import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanDetailsComponent } from './plan-details.component';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';



@NgModule({
  declarations: [
    PlanDetailsComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    DialogContainerModule
  ]
})
export class PlanDetailsModule { }
